import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { ServicePackageFragmentFragmentDoc } from '../fragments/servicePackage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ServicePackagesQueryVariables = Types.Exact<{
  currencies?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
}>;


export type ServicePackagesQuery = { __typename?: 'Query', servicePackages: Array<{ __typename?: 'ServicePackage', id: string, package_type: Types.ServicePackageType, currency: string, created_at: string, revisions: Array<{ __typename?: 'ServicePackageRevision', id: string, revision_number: number, min_contract_term_months: number, monthly_service_fee_in_cents: number, onboarding_fee_in_cents: number, ops_order_price_in_cents: number, note?: string | null, created_at: string, created_by?: string | null, allowances: Array<{ __typename?: 'ServicePackageAssetAllowance', id: string, monthly_quantity: number, item: { __typename?: 'ItemType', id: number, name: string } }>, free_checkouts: Array<{ __typename?: 'ServicePackageFreeCheckout', id: string, segment: Types.ContainerTypeSegment, amount: number }> }> }> };


export const ServicePackagesDocument = gql`
    query servicePackages($currencies: [String!]) {
  servicePackages(currencies: $currencies) {
    ...ServicePackageFragment
  }
}
    ${ServicePackageFragmentFragmentDoc}`;

/**
 * __useServicePackagesQuery__
 *
 * To run a query within a React component, call `useServicePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useServicePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServicePackagesQuery({
 *   variables: {
 *      currencies: // value for 'currencies'
 *   },
 * });
 */
export function useServicePackagesQuery(baseOptions?: Apollo.QueryHookOptions<ServicePackagesQuery, ServicePackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServicePackagesQuery, ServicePackagesQueryVariables>(ServicePackagesDocument, options);
      }
export function useServicePackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServicePackagesQuery, ServicePackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServicePackagesQuery, ServicePackagesQueryVariables>(ServicePackagesDocument, options);
        }
export type ServicePackagesQueryHookResult = ReturnType<typeof useServicePackagesQuery>;
export type ServicePackagesLazyQueryHookResult = ReturnType<typeof useServicePackagesLazyQuery>;
export type ServicePackagesQueryResult = Apollo.QueryResult<ServicePackagesQuery, ServicePackagesQueryVariables>;